
import React, {  useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Car, AlertCircle } from 'lucide-react';

const VehicleForm = ({ vehicle, onSubmit, onCancel, isLoading = false }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: vehicle || {}
  });

  useEffect(() => {
    if (vehicle) {
      reset(vehicle);
    }
  }, [vehicle, reset]);

  const onSubmitForm = (data) => {
    // Convert string dates to proper format
    const formattedData = {
      ...data,
      status:"Active",
      year: data.year ? parseInt(data.year) : null,
      last_service_mileage: data.last_service_mileage ? parseInt(data.last_service_mileage) : null,
      next_service_mileage: data.next_service_mileage ? parseInt(data.next_service_mileage) : null,
    };
    onSubmit(formattedData);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center gap-2 mb-6">
        <Car className="w-6 h-6 text-blue-600" />
        <h2 className="text-xl font-semibold text-gray-900">
          {vehicle ? 'Edit Vehicle' : 'Add New Vehicle'}
        </h2>
      </div>

      <form onSubmit={handleSubmit(onSubmitForm)} className="space-y-6">
        {/* Basic Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Registration Number *
            </label>
            <input
              type="text"
              {...register('registration_no', {
                required: 'Registration number is required',
                pattern: {
                  value: /^[A-Z0-9\s-]+$/i,
                  message: 'Invalid registration format'
                }
              })}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.registration_no ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., RAB 123A"
              style={{ textTransform: 'uppercase' }}
            />
            {errors.registration_no && (
              <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="w-4 h-4" />
                {errors.registration_no.message}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Make/Model *
            </label>
            <input
              type="text"
              {...register('make', {
                required: 'Make/Model is required'
              })}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.make ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Toyota Hiace"
            />
            {errors.make && (
              <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="w-4 h-4" />
                {errors.make.message}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Manufacturing Year
            </label>
            <input
              type="number"
              {...register('year', {
                min: {
                  value: 1990,
                  message: 'Year must be 1990 or later'
                },
                max: {
                  value: new Date().getFullYear() + 1,
                  message: 'Year cannot be in the future'
                }
              })}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.year ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="2020"
              min="1990"
              max={new Date().getFullYear() + 1}
            />
            {errors.year && (
              <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                <AlertCircle className="w-4 h-4" />
                {errors.year.message}
              </p>
            )}
          </div>

        
        </div>

        {/* Service Information */}
        {/* <div className="border-t pt-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
            <Gauge className="w-5 h-5 text-blue-600" />
            Service Information
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Service Mileage (km)
              </label>
              <input
                type="number"
                {...register('last_service_mileage', {
                  min: {
                    value: 0,
                    message: 'Mileage cannot be negative'
                  }
                })}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.last_service_mileage ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="50000"
                min="0"
              />
              {errors.last_service_mileage && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                  <AlertCircle className="w-4 h-4" />
                  {errors.last_service_mileage.message}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Service Date
              </label>
              <input
                type="date"
                {...register('last_service_date')}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Next Service Mileage (km)
              </label>
              <input
                type="number"
                {...register('next_service_mileage', {
                  min: {
                    value: 0,
                    message: 'Mileage cannot be negative'
                  }
                })}
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  errors.next_service_mileage ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="60000"
                min="0"
              />
              {errors.next_service_mileage && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                  <AlertCircle className="w-4 h-4" />
                  {errors.next_service_mileage.message}
                </p>
              )}
            </div>
          </div>
        </div> */}

        {/* Inspection and Insurance */}
        {/* <div className="border-t pt-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
            <FileText className="w-5 h-5 text-blue-600" />
            Documentation
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                Last Inspection Date
              </label>
              <input
                type="date"
                {...register('control_technique_date')}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-1">
                <Shield className="w-4 h-4" />
                Insurance Expiry Date
              </label>
              <input
                type="date"
                {...register('insurance_expiry_date')}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div> */}

        {/* Form Actions */}
        <div className="border-t pt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Saving...' : (vehicle ? 'Update Vehicle' : 'Add Vehicle')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default VehicleForm;